import { render, staticRenderFns } from "./featured.vue?vue&type=template&id=46dc34f0&scoped=true"
import script from "./featured.vue?vue&type=script&lang=js"
export * from "./featured.vue?vue&type=script&lang=js"
import style0 from "./featured.vue?vue&type=style&index=0&id=46dc34f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc34f0",
  null
  
)

export default component.exports